import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ComboButton from '@bibliocommons/base-combo-button';
import * as Icons from '@bibliocommons/base-icons';
import BibScreenReaderDescription from '@bibliocommons/shared-bib-screen-reader-description';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bibBriefShape, childrenShape } from '@bibliocommons/bc-prop-types';
import { SHELF_NAMES } from '../../../constants/ShelfConstants';

import './AddToShelfComboButton.scss';

const defaultShelfOrder = [
  SHELF_NAMES.FOR_LATER,
  SHELF_NAMES.IN_PROGRESS,
  SHELF_NAMES.COMPLETED
];

export default class AddToShelfComboButton extends BcReactComponent {
  renderAddToShelfButtonContent(name) {
    const formattedShelfName = <FormattedMessage id={`label_shelf_${name}`} />;
    return (
      <span>
        <Icons.ShelfItem color="currentColor" />
        <span className="shelf-name-text" aria-hidden="true">
          {formattedShelfName}
        </span>

        <ScreenReaderMessage>
          {this.renderShelfSrMessage(formattedShelfName)}
        </ScreenReaderMessage>
      </span>
    );
  }

  getContentScreenReaderTitle() {
    const { bibBrief } = this.props;

    return bibBrief ?
      <BibScreenReaderDescription bibBrief={bibBrief} /> :
      <FormattedMessage id="selected_items" />;
  }

  renderShelfSrMessage(shelfName) {
    return (
      <FormattedMessage
        id="ada_add_to_named_shelf"
        values={{
          title: this.getContentScreenReaderTitle(),
          shelf: shelfName
        }} />
    );
  }

  getShelfOptions() {
    const shelfNamesOrder = this.props.primaryShelfAction ? this.setPrimaryShelfOption() : defaultShelfOrder;

    return shelfNamesOrder.map(name => ({
      label: this.renderAddToShelfButtonContent(name),
      value: name
    }));
  }

  setPrimaryShelfOption() {
    return [this.props.primaryShelfAction, ...defaultShelfOrder.filter(shelf => shelf !== this.props.primaryShelfAction)];
  }

  renderSecondaryAriaLabel() {
    return (
      <FormattedMessage
        id="ada_add_to_different_shelf"
        values={{ title: this.getContentScreenReaderTitle() }} />
    );
  }

  render() {
    return (
      <div className="cp-add-to-shelf-combo-button">
        <ComboButton
          ButtonTag={this.props.ButtonTag}
          right
          disabled={this.props.disabled}
          isLoading={this.props.isLoading}
          options={this.getShelfOptions()}
          secondaryAriaLabel={this.renderSecondaryAriaLabel()}
          handleClick={this.props.handleClick}
          dataKey="bib-shelf-button">
          {this.props.children}
        </ComboButton>
      </div>
    );
  }
}

AddToShelfComboButton.propTypes = {
  disabled: PropTypes.bool,
  children: childrenShape,
  handleClick: PropTypes.func,
  bibBrief: bibBriefShape,
  isLoading: PropTypes.bool,
  ButtonTag: PropTypes.oneOfType([
    PropTypes.instanceOf(BcReactComponent),
    PropTypes.func
  ]),
  primaryShelfAction: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/shared/AddToShelfComboButton/AddToShelfComboButton.jsx